import React from "react";
import EmptyStateContainer from "../../../themes/components/EmptyStateContainer";

type SegmentEmptyStateProps = {
  onCreateClick?: () => void;
};

const SegmentEmptyState: React.FC<SegmentEmptyStateProps> = ({
  onCreateClick,
}) => (
  <EmptyStateContainer
    title="You have no segments"
    description="Create segments to group employees based on rules and criteria"
    button={
      onCreateClick
        ? {
            onClick: onCreateClick,
            title: "Create Segment",
          }
        : undefined
    }
  />
);

export default SegmentEmptyState;
